import React from 'react';
import { ComponentType } from "react";

export const Divider: ComponentType<{
  bg?: string
  className?: string
}> = ({
  bg = 'bg-onPrimary',
  className = ''
}) => (
    <div className={`w-full h-px my-4 ${bg} ${className}`} />
  )
